import _styled from "styled-components";
const _excluded = ["className", "style", "placement", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { variantSwitch } from '@adsk/alloy-react-helpers';
import { stylePropType } from '@adsk/alloy-react-theme';
import { PLACEMENTS } from '../consts';
import { getMainAxisPlacement } from '../helpers';
const Blank = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      style,
      placement,
      size
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    ref: ref,
    className: className
  }, props, {
    $_css: [{
      position: 'absolute'
    }, variantSwitch({
      statement: getMainAxisPlacement(placement),
      variants: {
        [PLACEMENTS.LEFT]: {
          top: 0,
          left: '100%',
          width: size,
          height: '100%'
        },
        [PLACEMENTS.RIGHT]: {
          top: 0,
          right: '100%',
          width: size,
          height: '100%'
        },
        [PLACEMENTS.TOP]: {
          left: 0,
          top: '100%',
          width: '100%',
          height: size
        },
        [PLACEMENTS.BOTTOM]: {
          left: 0,
          bottom: '100%',
          width: '100%',
          height: size
        }
      }
    }), style]
  }));
});
Blank.displayName = 'Blank';
Blank.propTypes = {
  /** className */
  className: PropTypes.string,
  /** Size */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** style */
  style: stylePropType,
  /** placement */
  placement: PropTypes.oneOf(Object.values(PLACEMENTS))
};
export default Object.assign(Blank, {
  PLACEMENTS
});
var _StyledDiv = _styled("div").withConfig({
  displayName: "Blank___StyledDiv",
  componentId: "sc-jghs5x-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Blank.js.map